export function SET_FETCH_LOTES_LIST(state, flag) {
  state.fetchLotesList = flag;
}

export function SET_LOTE_SELECTED(state, lote) {
  state.loteSelected = lote;
}

export function SET_MO_SELECTED(state, mo) {
  state.moSelected = mo;
}

export function SET_FORMULATION(state, item) {
  state.formulationSelected = item;
}

export function SET_PRODUCTS_SELECTED(state, items) {
  state.productsSelected = items;
}

export function SET_PRODUCT_SELECTED(state, item) {
  state.productSelected = item;
}
